module.exports = __webpack_public_path__ + "static/media/fasad8.90b34542.jpeg";